<google-map
  [center]="center"
  (mapClick)="mapClicked($event)"
  [zoom]="6"
  width="100%"
  height="500px"
>
  <!--Need i=index in ngFor to pass it in the deleteMarker function below.-->
  <ng-container *ngIf="source != null">
    <map-marker
      *ngFor="let marker of locations; let i = index"
      [position]="{ lat: marker.geoLatitude ? marker.geoLatitude:0, lng: marker.geoLongitude?marker.geoLongitude:0 }"
      [openInfoWindow]="showInfoWindow"
      #markerElem="mapMarker"
      (mapClick)="openInfo(markerElem, infoWindow,marker)"
      [options]="{ label: marker.label, zIndex: i + 1 }"
    >
        <map-info-window #infoWindow="mapInfoWindow" [disableAutoPan]="true" [isOpen]="showInfoWindow">
          <label class="sr-bold">{{ 'LocationSpecificSurveyComponent-STEP_7_RADIUS' | translate }}</label>
          <select
            #radius
            class="browser-default"
            (change)="onRadiusChanged(marker.radius, marker.geoLatitude, marker.geoLongitude)"
            [(ngModel)]="marker.radius"
          >
            <option *ngFor="let radius of radii" [ngValue]="radius.value">
              {{ radius.display }}
            </option>
          </select>
          <a class="waves-effect waves-light btn" (click)="onMarkerDelete(marker)">
            {{ 'LocationSpecificSurveyComponent-STEP_7_REMOVE_PIN' | translate }}
          </a>
        </map-info-window>
      <map-circle
        *ngIf="marker.geoLatitude && marker.geoLongitude"
        [center]="{ lat: marker.geoLatitude, lng: marker.geoLongitude }"
        [radius]="marker.radius ? marker.radius * 1000 : null"
        [options]="{
      fillColor: marker.color ? marker.color : 'red',
      clickable: true,
      visible: showAll ? showAll : marker.visible,
      strokeWeight: 0
    }"
        (circleClick)="onMarkerClicked(marker)"
      >
      </map-circle>
    </map-marker>
  </ng-container>
</google-map>
